<div class="video_modal" *ngIf="exists" [class.active]="display">
    <app-video [videoUrl]="videoUrl" [isMetadataVisible]="false"></app-video>
</div>